import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getAllEquipments = detailed => {
  return dispatch => {
    dispatch({ type: "GET_ALL_EQUIPMENTS_LOADING" });
    api
      .equipmentsGetAll(detailed)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_ALL_EQUIPMENTS_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_ALL_EQUIPMENTS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetAllEquipmentsErrorAlertTitle",
          "Virhe kaikkien välineiden tai käyttöoikeuksien haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_ALL_EQUIPMENTS_SUCCEEDED",
  payload: { equipments: data },
});

const operationFail = () => ({
  type: "GET_ALL_EQUIPMENTS_FAIL"
});
